import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';
import { ReactComponent as CryptoIcon } from 'assets/icons/crypto.svg';

// Simple pulse animation
const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
  100% { transform: scale(1); opacity: 1; }
`;

export default function CryptoWithBadge() {
  return (
    <Box sx={{ position: 'relative', display: 'inline-block', width: '28px' }}>
      {/* Your crypto SVG */}
      <CryptoIcon width={28} height={28} />

      {/* Badge */}
      <Typography
        sx={{
          position: 'absolute',
          top: -6,
          right: -6,
          background: '#ff1744',
          color: 'white',
          fontSize: '0.3rem',
          fontWeight: 'bold',
          borderRadius: '10px',
          px: 0.3,
          py: 0,
          animation: `${pulse} 1.5s infinite ease-in-out`,
        }}
      >
        NEW
      </Typography>
    </Box>
  );
}
